class trackMyOrder extends HTMLElement {
    constructor() {
        super();

        /**
         * Store all element for further use
         * @type {Element}
         */
        this.trackSubmit = this.querySelector('[data-track-submit]');
        this.trackOrderNumber = this.querySelector('[data-track-order]');
        this.trackOrderEmail = this.querySelector('[data-track-email]');
        this.trackOrderEmailError = this.querySelector('[data-track-email-error]');
        this.trackOrderNumberError = this.querySelector('[data-track-number-error]');
        this.trackOrderGeneralError = this.querySelector('[data-track-general-error]');
    }

    /**
     * Attach event listeners
     */
    connectedCallback() {
        this.trackSubmit.addEventListener('click', this.submitRequest.bind(this));
        ['change','blur', 'keyup'].forEach( evt=> this.eventHandlers(evt));
    }

    /**
     * Add handlers for multiply event
     * @param event
     */
    eventHandlers(event) {
        this.trackOrderEmail.addEventListener(event, this.validateEmail.bind(this), false);
        this.trackOrderNumber.addEventListener(event, this.validateOrderNumber.bind(this), false);
    }

    /**
     * Check if email value is valid
     * @param email
     * @returns {boolean}
     */
    isValidEmail(email) {
        return email && /^[\w-\+\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
    }

    /**
     * Email field validation
     * @returns {boolean}
     */
    validateEmail() {
        const value = this.trackOrderEmail.value;

        if (value === '') {
            //Empty field behavior
            this.errorState(this.trackOrderEmail);
            return false;
        }

        if (value && !this.isValidEmail(value)) {
            //Not valid behavior
            this.errorState(this.trackOrderEmail);
            this.trackOrderEmailError.classList.remove('hidden');
            return false;
        } else {
            //Valid behavior
            this.trackOrderEmail.classList.remove('error');
            this.trackOrderEmailError.classList.add('hidden');
            this.validState(this.trackOrderEmail);
            return true;
        }
    }

    /**
     * Order number field validation
     * @returns {boolean}
     */
    validateOrderNumber() {
        const value = this.trackOrderNumber.value;

        if (value) {
            //Valid behavior
            this.trackOrderNumberError.classList.add('hidden');
            this.validState(this.trackOrderNumber);
            return true;
        } else {
            //Not valid behavior
            this.trackOrderNumberError.classList.remove('hidden');
            this.errorState(this.trackOrderNumber);
            return false;
        }
    }

    /**
     * Display error element and hide valid
     * @param field
     */
    errorState (field) {
        field.classList.add('error');
        field.classList.remove('valid');
    }

    /**
     * Display valid element and hide errors
     * @param field
     */
    validState (field) {
        field.classList.add('valid');
        field.classList.remove('error');
    }

    /**
     * Check if all field is valid
     * @returns {boolean}
     */
    validateForm() {
        const isEmailValid = this.validateEmail();
        const isOrderNumberValid = this.validateOrderNumber();

        return isEmailValid && isOrderNumberValid;
    }

    /**
     * Send request for check is order exist
     * @returns {Promise<void>}
     */
    async submitRequest() {
        const trackOrderEmailValue = this.trackOrderEmail.value;
        const trackOrderNumberValue = this.trackOrderNumber.value;
        const { mulesoftTokens } = window.apiEndpoints;
        const { clientId, clientSecret } = mulesoftTokens;
        const TRACK_ORDER_URL = window.apiEndpoints.mulesoft + '/exp-customer-api/api/orders/status';

        //Validate field before fetch
        const isValid = this.validateForm();

        //Hide general error container
        this.trackOrderGeneralError.classList.add('hidden');

        if (isValid) {
            //Showing the Page loader before request
            document.body.classList.remove('loaded');

            //Check is order exist
            const response = await fetch(TRACK_ORDER_URL, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "client-id": clientId,
                    "client-secret": clientSecret
                },
                body: JSON.stringify(
                    {email: trackOrderEmailValue.toLocaleLowerCase(), order_number: trackOrderNumberValue}
                )
            });

            if (response.ok) {
                //Redirect to Order status page
                const {order_status_url} = await response.json();
                window.location.href = order_status_url;
            } else {
                //hide loader
                document.body.classList.add('loaded');

                //Display general error container
                this.trackOrderGeneralError.classList.remove('hidden');
            }
        }
    }
}

customElements.define('track-my-order', trackMyOrder);